export default __webpack_public_path__ + "static/media/fetured-item-2.184ce620.png";